import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - REGISTER CLOSURE
 * =======================================
 *
 * @module webregister.routes.register-closure
 */
function RegiserClosureRoutesConfig($stateProvider: StateProvider) {
  const template = '<react-register-open-close></react-register-open-close>'
  $stateProvider
    .state(STATES.REGISTER_CLOSURE, {
      url: ROUTES.REGISTER_CLOSURE,
      template,
    })
    // The above state handles if we're directed by URL but we also need to handle
    // all of the existing UIRouter states that Webregister might direct to.
    .state(STATES.RESOLVE_REGISTER_CLOSURE_STATE, {
      template,
    })
    .state(STATES.CLOSE_REGISTER, {
      template,
    })
    .state(STATES.OPEN_REGISTER, {
      template,
    })
}

angular.module('webregister.routes').config(RegiserClosureRoutesConfig)
